import React, { FC, HTMLAttributes, useCallback, useEffect, useState } from 'react';
import { ProductTag } from './ProductTag';
import { ReactComponent as CloseButtonBlack } from '../assets/svg/close-button-black.svg';
import {ProductQuery, ProductSize} from '../types/types';
import { sortedSizeObjects } from '../utils/sortedSizes';
import {getProductSizes} from "../apis/products";

interface ProductCardProps extends HTMLAttributes<HTMLDivElement> {
  product: ProductQuery;
  deleteButton?: (productId: number) => void;
}

export const ProductCard: FC<ProductCardProps> = ({
                                                    product,
                                                    deleteButton,
                                                    ...props
                                                  }) => {
  const [sizeHover, setSizeHover] = useState(false);

    const sizeInfos = product.productSizes!
    const stockOfAllSize = sizeInfos?.map(s => s.currentStock)
        .reduce((sum, stock) => sum + stock, 0);
    const isAllSizeSoldOut = stockOfAllSize <= 0;


    /*useEffect(() => {
          const stockOfAllSize = sizes
            .map(s => s.currentStock)
            .filter(s => s > 0)
            .reduce((sum, stock) => sum + stock, 0);
          setIsAllSizeSoldOut(!stockOfAllSize);
          (sizeHover && sizeInfos.length === 0) &&
          getProductSizes(product.productId).then(res => {
              const productSize = res.data.payload
              const stockOfAllSize = productSize.map(s => s.currentStock)
                  .filter(s => s > 0)
                  .reduce((sum, stock) => sum + stock, 0);
              setSizeInfos(productSize);
              setIsAllSizeSoldOut(!stockOfAllSize);
          })
    }, [sizeHover]);*/

  const onHoverAction = useCallback(() => {
    setSizeHover(true);
  }, []);

  const onLeaveAction = useCallback(() => {
    setSizeHover(false);
  }, []);


  return (
      <div className="relative mb-5">
        {deleteButton && (
            <div
                onClick={() => deleteButton(product.productId)}
                className="absolute right-1 top-2"
                style={{ zIndex: 1 }}>
              {/* <div className="z-10 absolute right-4 top-4 grid place-content-center"> */}
              <CloseButtonBlack />
              {/* </div> */}
            </div>
        )}

            <div
                className="space-y-3 relative cursor-pointer"
                style={{ minWidth: 170 }}
            >
          {/*<div
              className="relative aspect-w-2 aspect-h-3 cursor-pointer rounded-sm overflow-hidden"
              style={{
                backgroundColor: '#F6F6F6',
                padding: 0,
              }}>*/}


                <div
                    {...props}
                    onTouchStart={onHoverAction}
                    onTouchEnd={onLeaveAction}
                    onMouseOver={onHoverAction}
                    onMouseLeave={onLeaveAction}
                    className={'relative aspect-w-2 aspect-h-3 object-contain bg-contain bg-no-repeat bg-center overflow-hidden'}
                    style={{backgroundColor: '#f5f5f5'}}
                >
                    <img
                        src={sizeHover && product.hoverUrl ? product.hoverUrl : product.thumbnailUrl}
                        alt=""
                        className="absolute w-full object-contain overflow-hidden"
                    />
                </div>
            </div>
            <div className="mt-2 h-28">
            {product.isBlackFriday && <ProductTag margin imageIn name={''} />}
            {sizeHover ? (
                <div className="justify-center z-10 top-0">
                  <p className="text-black text-12 font-normal pb-1">사이즈</p>
                  <div className={`flex flex-wrap break-all`}>
                      {sortedSizeObjects(sizeInfos, 'sizeName')?.map((item, index) => (
                          <p
                              key={index}
                              className={`pr-1 text-12 md:text-14 ${
                                  item.currentStock > 0 
                                      ? 'text-black' : 'text-gray-500 line-through'
                              }`}>
                                {item.sizeName}
                              </p>
                            ))
                      }
                  </div>
                </div>
            ) : (
                <>
                    <div className="flex flex-wrap">
                        {product.isMidsale && <ProductTag margin name={'시즌 오프'} />}
                        {product.isNewArrival && <ProductTag margin name={'신상품'} />}
                        {product.isOnlyForUser && <ProductTag margin name={'회원전용'} />}
                        {product.isOnlyApp && <ProductTag margin name={'앱전용'} />}
                    </div>

                    <div className="text-12 md:text-15">
                      <p className="font-bold leading-tight break-all">
                          {product.productName}<br />
                          {product.color}
                      </p>

                      {isAllSizeSoldOut ? (
                        <p className="text-gray-400 text-14 font-normal">품절</p>
                      ) : (
                        <>
                          <p className="font-bold">₩{product.currentPrice.toLocaleString()}</p>
                          {product.discountedRate > 0 && (
                            <>
                              <span className="sale_color text-13 font-bold">
                                  ▼{product.discountedRate}%
                              </span>
                              &nbsp;&nbsp;
                              <span className="text-gray-400 text-13 line-through font-bold">
                                  ₩ {product.initialPrice.toLocaleString()}
                              </span>
                            </>
                          )}
                        </>
                      )}
                    </div>
                </>
                )}
          </div>
          {/*</div>*/}
      </div>
  );
};
